<template>
    <div class="rightSideBar corporateInvoicePanel expand animated fadeInRight OrchestrationEventsDetailContainer">
        <div class="orchEventEditContainer orchestrationEventsTopContainer">
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Message ID</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.MessageId ? orchestrationEventDetailsData.MessageId : '-' }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Message Type</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.MessageType ? orchestrationEventDetailsData.MessageType : '-' }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">CRS ID</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.CrsId ? orchestrationEventDetailsData.CrsId : '-'}}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Unit ID</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.UnitId ? orchestrationEventDetailsData.UnitId : '-'}}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">CRS Property ID</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.CrsPropertyId ? orchestrationEventDetailsData.CrsPropertyId : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Module Detail</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.ModuleDetail ? orchestrationEventDetailsData.ModuleDetail : "-" }}</h5>
            </div>
            <!-- <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Start Date</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.StartDate ? formatDate(orchestrationEventDetailsData.StartDate) : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">End Date</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.EndDate ? formatDate(orchestrationEventDetailsData.EndDate) : "-" }}</h5>
            </div> -->
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Sync Status ID</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.CrsPropertyId ? orchestrationEventDetailsData.CrsPropertyId : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Try Count</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.TryCount ? orchestrationEventDetailsData.TryCount : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Created Date</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.CreatedDate ? formatDate(orchestrationEventDetailsData.CreatedDate) : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Client ID</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.ClientId ? orchestrationEventDetailsData.ClientId : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Unit Type</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.UnitType ? orchestrationEventDetailsData.UnitType : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Restriction Types</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.RestrictionTypes ? orchestrationEventDetailsData.RestrictionTypes : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Rateplan ID</span><br/>
                <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.RateplanIds ? orchestrationEventDetailsData.RateplanIds : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Integration ID</span><br/>
                <!-- Overriding the IntegrationId to 1, when CrsId = 2 -->
                <h5 v-if="orchestrationEventDetailsData.CrsId == 2" class="orchestrationEventsTopContainerItemValue">{{  "1" }}</h5>
                <h5 v-else class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.IntegrationId ? orchestrationEventDetailsData.IntegrationId : "-" }}</h5>
            </div>
            <div class="orchestrationEventsTopContainerItems">
                <span class="orchestrationEventsTopContainerItemHeading">Source</span><br/>
                <!-- <h5 class="orchestrationEventsTopContainerItemValue">{{ orchestrationEventDetailsData.SourceName ? orchestrationEventDetailsData.SourceName : "-" }}</h5> -->
                <h5 class="orchestrationEventsTopContainerItemValue">
                  <span v-if="orchestrationEventDetailsData.SourceName" class="sourceAlignment resDetailSource" :class="orchestrationEventDetailsData.SourceName"></span>
                  <span v-else>-</span>
                </h5>
            </div>
        </div>
        <div class="orchestrationEventsDetailHeading" @click="toggleSection('xmlData')">
          <h5 class="mt-3">
              <i v-if="showXmlData" class="fa fa-chevron-down mr-2"></i>
              <i v-if="!showXmlData" class="fa fa-chevron-right mr-2"></i>
              Request
          </h5>
        </div>
      <div class="orchEventEditContainer bodyContainer" v-show="showXmlData">
        <!-- <h5>XML Data</h5> -->
        <!-- <textarea rows="8" cols="30" class="form-control" v-model="orchestrationEventDetailsData.XMLData" disabled></textarea> -->
         <div v-if="orchestrationEventDetailsData.CrsId == 2" class="orchestrationEventbodyView">
            <!-- <XmlViewer v-if="isValidXml(orchestrationEventDetailsData.XMLData)" :xml="orchestrationEventDetailsData.XMLData" />
            <span v-else>{{ orchestrationEventDetailsData.XMLData===null ? 'Null' : orchestrationEventDetailsData.XMLData }}</span> -->
            <span v-if="orchestrationEventDetailsData.XMLData===null">{{ 'Null' }}</span>
            <XmlViewer v-else-if="orchestrationEventDetailsData.XMLData.includes('<') && orchestrationEventDetailsData.XMLData.includes('>')" :xml="orchestrationEventDetailsData.XMLData" />
            <span v-else>{{ orchestrationEventDetailsData.XMLData }}</span>
         </div>
         <div v-else class="orchestrationEventbodyView">
            <tree-view :data="parsedReqBody" :options="{maxDepth: 100}"></tree-view>
         </div>
         <button v-show="orchestrationEventDetailsData.XMLData != null" v-if="orchestrationEventDetailsData.CrsId == 2" @click="copyDataToClipboard(orchestrationEventDetailsData.XMLData)" class="reqBodyCopyButton" title="copy to clipboard">
            <span v-show="copyClicked" class="copiedTextStyle">copied</span>
            <i v-show="!copyClicked" class="fa fa-clone" aria-hidden="true"></i>
            <i v-show="copyClicked" class="fa fa-check" aria-hidden="true"></i>
         </button>
         <button v-show="orchestrationEventDetailsData.XMLData != null" v-else @click="copyDataToClipboard(JSON.stringify(JSON.parse(orchestrationEventDetailsData.XMLData),null, 2))" class="reqBodyCopyButton" title="copy to clipboard">
            <span v-show="copyClicked" class="copiedTextStyle">copied</span>
            <i v-show="!copyClicked" class="fa fa-clone" aria-hidden="true"></i>
            <i v-show="copyClicked" class="fa fa-check" aria-hidden="true"></i>
         </button>
      </div>
      <div class="orchestrationEventsDetailHeading" @click="toggleSection('crsResponse')" >
          <h5 class="mt-3">
              <i v-if="showCrsResponse" class="fa fa-chevron-down mr-2"></i>
              <i v-if="!showCrsResponse" class="fa fa-chevron-right mr-2"></i>
              Response
          </h5>
      </div>
      <div class="orchEventEditContainer bodyContainer" v-show="showCrsResponse">
        <!-- <h5>CRS Response</h5> -->
         <!-- <textarea rows="8" cols="30" class="form-control" v-model="orchestrationEventDetailsData.CrsRespone" disabled></textarea> -->
          <div v-if="orchestrationEventDetailsData.CrsId == 2" class="orchestrationEventbodyView">
            <!-- <XmlViewer v-if="isValidXml(orchestrationEventDetailsData.CrsRespone)" :xml="orchestrationEventDetailsData.CrsRespone" />
            <span v-else>{{ orchestrationEventDetailsData.CrsRespone === null ? 'Null' :  orchestrationEventDetailsData.CrsRespone }}</span> -->
            <span v-if="orchestrationEventDetailsData.CrsRespone===null">{{ 'Null' }}</span>
            <XmlViewer v-else-if="orchestrationEventDetailsData.CrsRespone.includes('<') && orchestrationEventDetailsData.CrsRespone.includes('>')" :xml="orchestrationEventDetailsData.CrsRespone" />
            <span v-else>{{ orchestrationEventDetailsData.CrsRespone }}</span>
          </div>
          <div v-else class="orchestrationEventbodyView">
            <tree-view :data="parsedResBody" :options="{maxDepth: 100}"></tree-view>
         </div>
        <button v-show="orchestrationEventDetailsData.CrsRespone != null" @click="copyDataToClipboard(orchestrationEventDetailsData.CrsRespone)" class="reqBodyCopyButton" title="copy to clipboard">
            <span v-show="copyClicked" class="copiedTextStyle">copied</span>
            <i v-show="!copyClicked" class="fa fa-clone" aria-hidden="true"></i>
            <i v-show="copyClicked" class="fa fa-check" aria-hidden="true"></i>
        </button>
      </div>
  </div>
</template>
<script>
import Vue from 'vue'
import XmlViewer from 'vue-xml-viewer'
import CompositionApi from '@vue/composition-api'
import TreeView from "vue-json-tree-view";
import moment from 'moment';
Vue.use(TreeView);
Vue.use(CompositionApi);
export default {
    name:'orchestrationEventDetails',
    props:['orchestrationEventDetailsData', 'dateFormatToDisplay'],
    components: {
        XmlViewer
    },
    data(){
        return{
            showCrsResponse: false,
            showXmlData: true,
            copyClicked: false
        }
    },
    methods: {
        toggleSection(section) {
            if (section === 'crsResponse') {
                this.showCrsResponse = true;
                this.showXmlData = false;
            } else {
                this.showCrsResponse = false;
                this.showXmlData = true;
            }
        },
        copyDataToClipboard(strData) {
            navigator.clipboard.writeText(strData).then(() => {
                // alert('JSON copied to clipboard');
                this.copyClicked=true;
                setTimeout(() => {
                    this.copyClicked=false;
                }, 1000);
            }).catch(err => {
                console.log('Failed to copy XML:', err);
            });
        },
        formatDate(isoDate) {
            if (!isoDate) return '';
            // return moment(isoDate).utc().format("MMMM Do YYYY")
            return this.dateFormatToDisplay === 'utc' ? moment(isoDate).utc().format("MMMM Do YYYY") : moment(isoDate).local().format("MMMM Do YYYY");
            // return moment.utc(isoDate).format('MMMM Do YYYY, h:mm:ss A');
            
        },
        // isValidXml(xmlString) {
        //     if (typeof xmlString !== 'string' || xmlString.trim() === '') {
        //         return false;
        //     }
        //     try {
        //         const parser = new DOMParser();
        //         const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
        //         const parserErrors = xmlDoc.getElementsByTagName('parsererror');
        //         return parserErrors.length === 0;
        //     } catch (error) {
        //         console.error('XML parsing error:', error);
        //         return false;
        //     }
        // },
    },
    computed: {
        parsedReqBody() {
            try {
                if (this.orchestrationEventDetailsData.XMLData && typeof this.orchestrationEventDetailsData.XMLData === 'string') {
                    return JSON.parse(this.orchestrationEventDetailsData.XMLData);
                } else {
                    return this.orchestrationEventDetailsData.XMLData;  
                }
            } catch (error) {
                return 'Invalid Request:';  
            }
        },
        parsedResBody() {
            try {
                if (this.orchestrationEventDetailsData.CrsRespone && typeof this.orchestrationEventDetailsData.CrsRespone === 'string') {
                    return JSON.parse(this.orchestrationEventDetailsData.CrsRespone);
                } else {
                    return this.orchestrationEventDetailsData.CrsRespone;  
                }
            } catch (error) {
                return this.orchestrationEventDetailsData.CrsRespone;  
            }
        }
    }

}
</script>

<style scoped>
.OrchestrationEventsDetailContainer{
  padding: 10px 0px 20px 20px;
  background: white;
  overflow: auto;
}
.orchestrationEventbodyView{
    padding: 10px 10px 10px 30px;
    background-color: #ebeef5;
    color: black;
    border-radius: 10px;
    /* max-height: 700px; */
    max-height: 45vh;
    overflow: auto;
    position: relative;
}
.orchestrationEventsDetailHeading{
    height:37px;
    border-bottom:#cccccc solid 1px;
    line-height: 60px;
    cursor: pointer;
}
.reqBodyCopyButton{
    background-color: #ebeef5;
    color: black;
    padding: 0px;
    border: 0px;
    cursor: pointer;
    position: absolute;
    top: 30px;
    right: 30px;
}
.reqBodyCopyButton:focus{
    outline: none;
    box-shadow: none;
}
.copiedTextStyle{
    font-size: 14px;
    margin-right: 3px;
}
.bodyContainer{
    background: white;
    position: relative;
}
.orchestrationEventsTopContainer{
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    height: 30vh;
    margin-right: 10px;
}
.orchestrationEventsTopContainerItems{
    width: 31%;
    margin-right: 10px;
}
.orchestrationEventsTopContainerItemHeading{
    font-size: 13px;
    color: gray;
}
.orchestrationEventsTopContainerItemValue{
    font-size: 14px;
    font-weight: 600;
}
.sourceAlignment{
    margin: 0px 0px 0 0 !important;
}
</style>